<template>
  <div class="submission" v-if="$can('manage_items_view')">
    <v-snackbar v-model="snackbar" :timeout="4000" bottom right :color="color">
      <span>{{ message }}</span>
    </v-snackbar>
    <v-dialog
      transition="dialog-bottom-transition"
      max-width="600"
      v-model="itemDialog"
    >
      <v-card max-width="600">
        <v-toolbar flat>
          {{ $t("uploadItemMsg") }}
          <v-spacer></v-spacer>
          <v-btn icon @click="itemDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-form ref="itemForm" lazy-validation>
          <v-layout column>
            <v-flex xs12>
              <v-file-input
                class="mx-2 mt-3"
                :loading="itemLoading"
                :rules="fileRules"
                outlined
                dense
                show-size
                chips
                v-model="itemFile"
                :label="$t('selectItemToUploadMsg')"
              ></v-file-input>
            </v-flex>
            <v-flex xs12>
              <div align="right" class="mb-3 mx-3">
                <v-btn
                  depressed
                  block
                  class="primary text-none"
                  @click="uploadItem"
                  :loading="itemLoading"
                  :disabled="!itemValid"
                >
                  {{ $t("submitMessage") }}
                  <v-icon right dark>mdi-upload</v-icon>
                </v-btn>
              </div>
            </v-flex>
          </v-layout>
        </v-form>
      </v-card>
    </v-dialog>
    <v-container>
      <v-layout column>
        <div v-if="view == 'default'">
          <v-card outlined class="mt-5 pa-3" style="border-radius: 25px">
            <v-flex xs12 class="mt-10 mb-2">
              <div class="mx-5">
                <v-layout row wrap>
                  <v-flex xs12 md4>
                    <h1>{{ $t("manageItemsMsg") }}</h1>
                  </v-flex>
                  <v-flex xs12 md4>
                    <div class="pa-1">
                      <v-text-field
                        class="text_field header"
                        outlined
                        dense
                        label="Search"
                        append-icon="mdi-undo-variant"
                        @click:append="resetSearch()"
                        v-on:keyup.enter="search"
                        v-model="searchTerm"
                        @input="enableSearch()"
                      >
                      </v-text-field>
                    </div>
                  </v-flex>
                  <v-flex xs12 md2>
                    <div class="pa-1">
                      <v-btn
                        class="secondary white--text text-none"
                        depressed
                        block
                        @click="search"
                        :loading="searchLoader"
                        :disabled="searchButtonDisabled"
                      >
                        {{ $t("searchMsg") }}
                        <v-icon right>mdi-magnify</v-icon>
                      </v-btn>
                    </div>
                  </v-flex>
                  <v-flex xs12 md2>
                    <div class="pa-1">
                      <v-btn
                        block
                        depressed
                        class="primary text-none"
                        @click="changeView('create')"
                        v-if="$can('manage_items_create')"
                      >
                        {{ $t("addItemMsg") }}
                        <v-icon right> mdi-plus-circle-outline </v-icon>
                      </v-btn>
                    </div>
                  </v-flex>
                </v-layout>
              </div>
            </v-flex>
            <div class="mx-5 mt-9">
              <v-progress-linear
                v-if="submissionLoader"
                height="1"
                indeterminate
                color="primary"
              ></v-progress-linear>
            </div>
            <v-divider class="mx-5"></v-divider>
            <v-flex xs12 class="mt-5">
              <div v-if="submission.length == 0">
                <v-card elevation="0">
                  <v-layout row wrap>
                    <v-flex xs12 md1>
                      <v-container fill-height fluid>
                        <v-row align="center" justify="center">
                          <v-col class="text-center">
                            <v-icon large class="white--text">
                              mdi-alert-circle-outline
                            </v-icon>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-flex>
                    <v-flex xs12 md11>
                      <v-container fill-height fluid>
                        <v-row align="center" justify="center">
                          <v-col class="text-center">
                            {{ $t("noItemFoundMsg") }}
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-flex>
                  </v-layout>
                </v-card>
              </div>
              <div v-else>
                <div class="hidden-sm-and-down">
                  <v-card elevation="0" class="pa-2">
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr class="tableHeader">
                            <th class="text-left text--text">
                              {{ $t("titleMsg") }}
                            </th>
                            <th class="text-left text--text">
                              {{ $t("descriptionMsg") }}
                            </th>
                            <th class="text-left text--text">
                              {{ $t("typeMsg") }}
                            </th>
                            <th class="text-left text--text">
                              {{ $t("viewMoreCountry") }}
                            </th>
                            <th class="text-left text--text">
                              {{ $t("classificationMsg") }}
                            </th>
                            <th class="text-left text--text">
                              {{ $t("accessLevelMsg") }}
                            </th>
                            <th class="text-left text--text">
                              {{ $t("tagsMsg") }}
                            </th>
                            <th class="text-right text--text">
                              {{ $t("actionsMsg") }}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="item in submission" :key="item.id">
                            <td>
                              <div
                                v-if="highLightId == item.id"
                                class="green--text"
                              >
                                {{ item.title }}
                              </div>
                              <div v-else>
                                {{ item.title }}
                              </div>
                            </td>
                            <td>
                              <div
                                v-if="highLightId == item.id"
                                class="green--text"
                              >
                                {{ item.description }}
                              </div>
                              <div v-else>
                                {{ item.description }}
                              </div>
                            </td>
                            <td>
                              <div
                                v-if="highLightId == item.id"
                                class="green--text"
                              >
                                {{ item.submission_type.name }}
                              </div>
                              <div v-else>
                                {{ item.submission_type.name }}
                              </div>
                            </td>
                            <td>
                              <div
                                v-if="highLightId == item.id"
                                class="green--text"
                              >
                                {{ item.country.iso3 }}
                              </div>
                              <div v-else>
                                {{ item.country.iso3 }}
                              </div>
                            </td>
                            <td>
                              <div
                                v-if="highLightId == item.id"
                                class="green--text"
                              >
                                {{ item.classification.name }}
                              </div>
                              <div v-else>
                                {{ item.classification.name }}
                              </div>
                            </td>
                            <td>
                              <div
                                v-if="highLightId == item.id"
                                class="green--text"
                              >
                                {{ item.access_level.name }}
                              </div>
                              <div v-else>
                                {{ item.access_level.name }}
                              </div>
                            </td>
                            <td>
                              <div
                                v-if="highLightId == item.id"
                                class="green--text"
                              >
                                {{ getListedTags(item.tags) }}
                              </div>
                              <div v-else>
                                {{ getListedTags(item.tags) }}
                              </div>
                            </td>
                            <td>
                              <div align="right">
                                <v-tooltip top v-if="$can('manage_items_view')">
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      icon
                                      @click="showSubmission(item)"
                                      class="button mr-1 blue--text"
                                      v-bind="attrs"
                                      v-on="on"
                                    >
                                      <v-icon small> mdi-eye </v-icon>
                                    </v-btn>
                                  </template>
                                  <span>{{ $t("viewMsg") }}</span>
                                </v-tooltip>
                                <!-- <v-tooltip top v-if="$can('manage_items_edit')">
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      icon
                                      @click="editSubmission(item)"
                                      class="button mr-1 success--text"
                                      v-bind="attrs"
                                      v-on="on"
                                    >
                                      <v-icon small> mdi-pencil </v-icon>
                                    </v-btn>
                                  </template>
                                  <span>{{ $t("editMsg") }}</span>
                                </v-tooltip> -->
                                <v-tooltip
                                  top
                                  v-if="$can('manage_items_archive')"
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      icon
                                      @click="deleteSubmission(item)"
                                      :loading="loading && itemIndex == item.id"
                                      class="button error--text"
                                      v-bind="attrs"
                                      v-on="on"
                                    >
                                      <v-icon small> mdi-delete </v-icon>
                                    </v-btn>
                                  </template>
                                  <span>{{ $t("archiveMsg") }}</span>
                                </v-tooltip>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-card>
                </div>
                <div class="hidden-md-and-up">
                  <v-layout column>
                    <template>
                      <div v-for="item in submission" :key="item.id">
                        <v-flex xs12 class="mb-2">
                          <v-card elevation="0">
                            <div class="pa-5">
                              <v-layout column>
                                <v-flex xs12>
                                  <v-layout row wrap>
                                    <v-flex xs11>
                                      <div class="title primary--text">
                                        <b>{{ item.title }}</b>
                                      </div>
                                      <div>
                                        <b>{{ $t("typeMsg") }}:</b>
                                        {{ item.submission_type.name }}
                                      </div>
                                      <div>
                                        <b>{{ $t("programmeMsg") }}:</b>
                                        {{ item.collection.community.name }}
                                      </div>
                                      <div>
                                        <b>{{ $t("projectMsg") }}:</b>
                                        {{ item.collection.name }}
                                      </div>
                                      <div></div>
                                      <div>
                                        <b>{{ $t("viewMoreCountry") }}:</b>
                                        {{ item.country.name }}
                                      </div>
                                      <div>
                                        <b>{{ $t("descriptionMsg") }}:</b>
                                      </div>
                                      <div>
                                        {{ item.description }}
                                      </div>
                                    </v-flex>
                                    <v-flex xs1>
                                      <v-btn
                                        v-if="$can('manage_items_view')"
                                        depressed
                                        class="blue--text"
                                        icon
                                        @click="showSubmission(item)"
                                      >
                                        <v-icon> mdi-eye </v-icon>
                                      </v-btn>
                                      <v-btn
                                        v-if="$can('manage_items_edit')"
                                        depressed
                                        class="success--text"
                                        icon
                                        @click="editSubmission(item)"
                                      >
                                        <v-icon> mdi-pencil </v-icon>
                                      </v-btn>
                                      <v-btn
                                        v-if="$can('manage_items_archive')"
                                        depressed
                                        class="red--text"
                                        :loading="
                                          loading && itemIndex == item.id
                                        "
                                        icon
                                        @click="deleteSubmission(item)"
                                      >
                                        <v-icon> mdi-delete </v-icon>
                                      </v-btn>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                                <v-divider class="mt-2"></v-divider>
                              </v-layout>
                            </div>
                          </v-card>
                        </v-flex>
                      </div>
                    </template>
                  </v-layout>
                </div>
              </div>
            </v-flex>
          </v-card>

          <v-layout column class="mt-5">
            <v-flex xs12>
              <div align="center">
                <v-pagination
                  v-if="length != 0"
                  :length="length"
                  total-visible="10"
                  v-model="submissionPagination.current_page"
                  @input="changePage()"
                  circle
                >
                </v-pagination>
              </div>
            </v-flex>
            <v-flex xs12>
              <div align="center" class="mt-5" v-if="length != 0">
                <b class="primary--text">{{ $t("totalMsg") }} </b
                >{{ submissionPagination.total }}
              </div>
            </v-flex>
          </v-layout>
        </div>
        <div v-if="view == 'create'">
          <v-flex class="mt-5">
            <v-card outlined>
              <v-card-title class="tableHeader text--text">
                <v-spacer></v-spacer>
                <div v-if="newItem.id == null">{{ $t("addItemMsg") }}</div>
                <div v-else>{{ $t("editItemMsg") }}</div>
                <v-spacer></v-spacer>
                <v-btn icon @click="changeView('default')">
                  <v-icon class="text--text"> mdi-close </v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text>
                <v-form v-model="valid" ref="form" lazy-validation>
                  <v-layout row wrap class="mt-5">
                    <v-col cols="12" class="d-flex">
                      <v-card outlined :loading="loading" class="pa-2">
                        <template slot="progress">
                          <v-progress-linear
                            color="deep-purple"
                            height="10"
                            indeterminate
                          ></v-progress-linear>
                        </template>
                        <!-- <img height="250" max-width="500px" v-if="newItem.itemFile != null"
                          :src="path + '/storage/app/private/items/' + newItem.itemFile" alt=""> -->
                        <v-card-actions>
                          <v-chip v-if="itemFile != null" class="mr-4 pa-4">
                            {{ itemFile.name }}
                          </v-chip>
                          <v-btn
                            depressed
                            class="text-none secondary white--text"
                            @click="openUploadDialog"
                          >
                            {{ $t("uploadItemMsg") }}
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-col>
                    <v-flex xs12 md6>
                      <div class="pa-3">
                        <div>{{ $t("titleMsg") }}</div>
                        <div>
                          <v-text-field
                            class="text_field background"
                            outlined
                            dense
                            v-model="newItem.title"
                            :rules="inputRules"
                          ></v-text-field>
                        </div>
                      </div>
                    </v-flex>
                    <v-flex xs12 md6>
                      <div class="pa-3">
                        <div>{{ $t("typeMsg") }}</div>
                        <div>
                          <v-select
                            :items="formData.submission_types"
                            v-model="newItem.submission_type_id"
                            class="text_field background"
                            item-value="id"
                            item-text="name"
                            outlined
                            dense
                            :rules="inputRules"
                          ></v-select>
                        </div>
                      </div>
                    </v-flex>
                    <v-flex xs12 md12>
                      <div class="pa-3">
                        <div>{{ $t("descriptionMsg") }}</div>
                        <div>
                          <v-textarea
                            class="text_field background"
                            outlined
                            dense
                            v-model="newItem.description"
                            :rules="inputRules"
                            rows="1"
                          ></v-textarea>
                        </div>
                      </div>
                    </v-flex>
                    <v-flex
                      xs12
                      md12
                      v-if="hasAbstract(newItem.submission_type_id)"
                    >
                      <div class="pa-3">
                        <div>{{ $t("abstractMsg") }}</div>
                        <div>
                          <v-textarea
                            class="text_field background"
                            outlined
                            dense
                            v-model="newItem.abstract"
                            :rules="inputRules"
                            rows="1"
                          ></v-textarea>
                        </div>
                      </div>
                    </v-flex>
                    <v-flex xs12 md6>
                      <div class="pa-3">
                        <div>{{ $t("programmeMsg") }}</div>
                        <div>
                          <v-select
                            :items="formData.communities"
                            v-model="newItem.community_id"
                            class="text_field background"
                            item-value="id"
                            item-text="name"
                            outlined
                            dense
                            :rules="inputRules"
                            @change="getProjects"
                          ></v-select>
                        </div>
                      </div>
                    </v-flex>
                    <v-flex xs12 md6>
                      <div class="pa-3">
                        <div>{{ $t("projectMsg") }}</div>
                        <div>
                          <v-select
                            :items="collections"
                            v-model="newItem.collection_id"
                            class="text_field background"
                            item-value="id"
                            item-text="name"
                            outlined
                            dense
                            :rules="inputRules"
                          ></v-select>
                        </div>
                      </div>
                    </v-flex>
                    <v-flex xs12 md6>
                      <div class="pa-3">
                        <div>{{ $t("viewMoreCountry") }}</div>
                        <div>
                          <v-select
                            :items="formData.countries"
                            v-model="newItem.country_id"
                            class="text_field background"
                            item-value="id"
                            item-text="name"
                            outlined
                            dense
                            :rules="inputRules"
                          ></v-select>
                        </div>
                      </div>
                    </v-flex>
                    <v-flex xs12 md6>
                      <div class="mx-2 mt-5">
                        <div>
                          <b>{{ $t("eventOrPublishDateMsg") }}</b>
                        </div>
                        <v-menu
                          :close-on-content-click="false"
                          max-width="290"
                          transition="scale-transition"
                          v-model="eventDate"
                          offset-y
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              outlined
                              dense
                              :value="formatEventDate"
                              slot="activator"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              class="text_field background"
                              append-icon="mdi-calendar"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="newItem.eventDate"
                            :max="dateToday"
                            @change="closeEventDate"
                          >
                          </v-date-picker>
                        </v-menu>
                      </div>
                    </v-flex>
                    <v-flex xs12 md6>
                      <div class="pa-3">
                        <div>{{ $t("classificationMsg") }}</div>
                        <div>
                          <v-select
                            :items="formData.classifications"
                            v-model="newItem.classification_id"
                            class="text_field background"
                            item-value="id"
                            item-text="name"
                            outlined
                            dense
                            :rules="inputRules"
                          ></v-select>
                        </div>
                      </div>
                    </v-flex>
                    <v-flex xs12 md6>
                      <div class="pa-3">
                        <div>{{ $t("accessLevelMsg") }}</div>
                        <div>
                          <v-select
                            :items="formData.access_levels"
                            v-model="newItem.access_level_id"
                            class="text_field background"
                            item-value="id"
                            item-text="name"
                            outlined
                            dense
                            :rules="inputRules"
                          ></v-select>
                        </div>
                      </div>
                    </v-flex>
                    <v-flex xs12 md6>
                      <div class="pa-3">
                        <div>{{ $t("latitudeMsg") }}</div>
                        <div>
                          <v-text-field
                            class="text_field background"
                            outlined
                            dense
                            v-model="newItem.latitude"
                          ></v-text-field>
                        </div>
                      </div>
                    </v-flex>
                    <v-flex xs12 md6>
                      <div class="pa-3">
                        <div>{{ $t("longitudeMsg") }}</div>
                        <div>
                          <v-text-field
                            class="text_field background"
                            outlined
                            dense
                            v-model="newItem.longitude"
                          ></v-text-field>
                        </div>
                      </div>
                    </v-flex>
                    <v-flex xs12 md12>
                      <div class="pa-3">
                        <div>{{ $t("tagsMsg") }}</div>
                        <div>
                          <v-combobox
                            v-model="newItem.tags"
                            :label="$t('tagsHintMsg')"
                            prepend-icon="mdi-filter-variant"
                            variant="solo"
                            chips
                            clearable
                            multiple
                          >
                            <template
                              v-slot:selection="{
                                attrs,
                                item,
                                select,
                                selected,
                              }"
                            >
                              <v-chip
                                v-bind="attrs"
                                :model-value="selected"
                                closable
                                @click="select"
                                @click:close="removeTags(item)"
                              >
                                <strong>{{ item }}</strong>
                              </v-chip>
                            </template>
                          </v-combobox>
                        </div>

                        <!-- <v-autocomplete
                              clearable
                              chips
                              label="Autocomplete"
                              :items="items"
                              multiple
                              v-model="chips"
                              :rules="inputRules"
                            ></v-autocomplete> -->
                      </div>
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  depressed
                  class="primary text-none mt-3"
                  @click="save"
                  :disabled="!valid"
                  :loading="loading"
                >
                  {{ $t("saveMsg") }}
                  <v-icon right> mdi-content-save </v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </div>
        <div v-if="view == 'show'">
          <v-card outlined class="mt-5">
            <v-card-title class="tableHeader text--text">
              {{ displaySubmission.title }} -
              {{ displaySubmission.submission_type }}
              <v-spacer></v-spacer>
              <v-btn icon @click="changeView('default')">
                <v-icon class="text--text"> mdi-close </v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <div class="pa-3">
                <v-layout row wrap>
                  <v-simple-table>
                    <template #default>
                      <tbody class="mb-10">
                        <tr>
                          <td colspan="2" rowspan="3">
                            <v-card
                              :loading="loading"
                              class="my-12"
                              width="500px"
                            >
                              <template slot="progress">
                                <v-progress-linear
                                  color="deep-purple"
                                  height="10"
                                  indeterminate
                                ></v-progress-linear>
                              </template>

                              <v-img height="250" max-width="500px" :src="displaySubmission.thumbnail_link"></v-img>

                              <v-divider class="mx-4"></v-divider>
                              <v-card-actions>
                                <v-btn
                                  color="secondary h1"
                                  text
                                  @click="downloadItem()"
                                  :loading="downloadLoading"
                                >
                                  {{ $t("downloadMsg") }}
                                  <v-icon right>mdi-download</v-icon>
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </td>
                          <td rowspan="3"></td>
                          <td rowspan="3" class="font-weight-bold">
                            {{ $t("tagsMsg") }}:
                          </td>
                          <td rowspan="3">
                            <v-chip
                              class="mr-1 mb-1"
                              v-for="(tag, index) in displaySubmission.tags"
                              :key="index"
                            >
                              {{ tag }}
                            </v-chip>
                          </td>
                        </tr>
                        <tr></tr>
                        <tr></tr>
                        <tr>
                          <td class="font-weight-bold">
                            {{ $t("programmeMsg") }}:
                          </td>
                          <td>{{ displaySubmission.programme }}</td>
                          <td class="pl-5"></td>
                          <td class="font-weight-bold">
                            {{ $t("projectMsg") }}:
                          </td>
                          <td>{{ displaySubmission.project }}</td>
                        </tr>
                        <tr>
                          <td class="font-weight-bold">
                            {{ $t("viewMoreCountry") }}:
                          </td>
                          <td>{{ displaySubmission.country }}</td>
                          <td></td>
                          <td class="font-weight-bold">
                            {{ $t("eventOrPublishDateMsg") }}:
                          </td>
                          <td>
                            {{
                              displaySubmission.date_created
                                | moment("DD-MMM-YYYY HH:mm:ss")
                            }}
                          </td>
                        </tr>
                        <tr>
                          <td class="font-weight-bold">
                            {{ $t("classificationMsg") }}:
                          </td>
                          <td>{{ displaySubmission.classification }}</td>
                          <td></td>
                          <td class="font-weight-bold">
                            {{ $t("accessLevelMsg") }}:
                          </td>
                          <td>{{ displaySubmission.access_level }}</td>
                        </tr>
                        <tr>
                          <td class="font-weight-bold">
                            {{ $t("coordinatesMsg") }}:
                          </td>
                          <td>{{ displaySubmission.coordinates }}</td>
                          <td></td>
                          <td class="font-weight-bold">
                            {{ $t("itemIDMsg") }}:
                          </td>
                          <td>{{ displaySubmission.code }}</td>
                        </tr>
                        <tr>
                          <td class="font-weight-bold">
                            {{ $t("uploadedByMsg") }}:
                          </td>
                          <td>{{ displaySubmission.create_user }}</td>
                          <td></td>
                          <td class="font-weight-bold">
                            {{ $t("uploadedOnMsg") }}:
                          </td>
                          <td>
                            {{
                              displaySubmission.created_at
                                | moment("DD-MMM-YYYY HH:mm:ss")
                            }}
                          </td>
                        </tr>
                        <tr>
                          <td class="font-weight-bold">
                            {{ $t("lastUpdateByMsg") }}:
                          </td>
                          <td>{{ displaySubmission.create_user }}</td>
                          <td></td>
                          <td class="font-weight-bold">
                            {{ $t("lastUpdateOnMsg") }}:
                          </td>
                          <td>
                            {{
                              displaySubmission.created_at
                                | moment("DD-MMM-YYYY HH:mm:ss")
                            }}
                          </td>
                        </tr>
                        <tr>
                          <td class="font-weight-bold">
                            {{ $t("descriptionMsg") }}:
                          </td>
                          <td colspan="4">
                            {{ displaySubmission.description }}
                          </td>
                        </tr>
                        <tr v-if="displaySubmission.recent_abstract != null">
                          <td class="font-weight-bold">
                            {{ $t("abstractMsg") }}:
                          </td>
                          <td colspan="4">
                            {{ displaySubmission.recent_abstract }}
                          </td>
                        </tr>
                        <tr style="height: 50px"></tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-layout>
              </div>
            </v-card-text>
          </v-card>
        </div>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import apiCall from "@/utils/api";
import { mapGetters, mapActions, mapMutations } from "vuex";
import { downloadFile } from "@/utils/download_file";
export default {
  components: {},
  data() {
    return {
      dashBreadcrumb: true,
      showBreadcrumb: false,

      view: "default",
      page: 1,
      loading: false,
      valid: true,
      message: "",
      color: "",
      delete: false,
      itemIndex: null,
      snackbar: false,
      searchFilter: null,
      formData: null,
      collections: [],
      eventDate: false,
      itemDialog: false,
      itemLoading: false,
      downloadLoading: false,
      fileRules: [(v) => !!v || this.$t("inputIsRequiredMessage")],
      itemValid: true,
      inputRules: [(v) => !!v || this.$t("inputIsRequiredMessage")],
      searchTerm: null,
      searchLoader: false,
      searchButtonDisabled: false,
      searchButtonDisabled: false,
      itemFile: null,
      newItem: {
        title: null,
        submission_type_id: null,
        description: null,
        community_id: null,
        collection_id: null,
        country_id: null,
        eventDate: null,
        classification_id: null,
        access_level_id: null,
        latitude: null,
        longitude: null,
        tags: null,
      },
      displaySubmission: {
        code: null,
        title: null,
        description: null,
        date_created: null,
        classification: null,
        access_level: null,
        country: null,
        latitude: null,
        longitude: null,
        project: null,
        community: null,
        recent_abstract: null,
        created_at: null,
        create_user: null,
        coordinates: null,
        tags: null,
        submission_type: null,
        thumbnail_link: null,
      },
      highLightId: null,
      assignButton: false,
      assignAllButton: false,
      removeButton: false,
      removeAllButton: false,
      months: [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
      ],
      monthNames: [
        { name: "January" },
        { name: "February" },
        { name: "March" },
        { name: "April" },
        { name: "May" },
        { name: "June" },
        { name: "July" },
        { name: "August" },
        { name: "September" },
        { name: "October" },
        { name: "November" },
        { name: "December" },
      ],
      filename: null,
    };
  },
  created() {
    this.setsubmission({
      data: [],
      current_page: 1,
      total: 0,
      per_page: 20
    })
    if (this.$can("manage_items_view")) {
      this.fetchsubmission(this.submissionPagination.current_page);
      this.getFormData();
    }
  },
  methods: {
    ...mapActions([
      "fetchsubmission",
      "startsubmissionLoader",
      "stopsubmissionLoader",
      "filtersubmission",
    ]),
    ...mapMutations([
      'setsubmission'
    ]),

    getFormData() {
      apiCall({
        url: "/api/submission?type=formData",
        method: "GET",
      })
        .then((resp) => {
          this.formData = resp;
        })
        .catch((error) => {
          this.message = this.$t("anErrorOccurredMsg");
          this.color = "error";
        });
    },
    getProjects() {
      this.collections = [];
      this.newItem.collection_id = null;
      let x = this.formData.communities.find(
        (x) => x.id == this.newItem.community_id
      );
      if (x != null) {
        this.collections = x.collection;
      }
    },
    getListedTags(tagsJson) {
      var max_size = 10;
      var values = JSON.parse(tagsJson); //.join(', ');
      if (values.length > max_size) {
        const slicedArray = values.slice(0, max_size);
        values = slicedArray;
        return values.join(", ") + "...";
      } else {
        return values.join(", ");
      }
    },
    hasAbstract(submission_type_id) {
      let x = this.formData.submission_types.find(
        (x) => x.id == submission_type_id
      );
      if (x != null) {
        if (x.has_abstract == 1) {
          return true;
        }
      }
      return false;
    },

    removeTags(item) {
      this.chips.splice(this.chips.indexOf(item), 1);
    },

    enableSearch() {
      this.searchButtonDisabled = false;
    },
    resetSearch() {
      (this.searchTerm = null), this.startsubmissionLoader();
      this.fetchsubmission(1);
    },
    resetFields() {
      this.newItem.title = null;
      this.newItem.submission_type_id = null;
      this.newItem.description = null;
      this.newItem.community_id = null;
      this.newItem.collection_id = null;
      this.newItem.country_id = null;
      this.newItem.eventDate = null;
      this.newItem.classification_id = null;
      this.newItem.access_level_id = null;
      this.newItem.latitude = null;
      this.newItem.longitude = null;
      this.newItem.tags = null;
      this.itemFile = null
    },
    showSubmission(item) {
      this.highLightId = item.id;
      this.displaySubmission.code = item.bitstream_uuid;
      this.displaySubmission.title = item.title;
      this.displaySubmission.file_type = item.file_type;
      this.displaySubmission.description = item.description;
      this.displaySubmission.submission_type = item.submission_type.name;
      this.displaySubmission.date_created = item.date_created; // | moment("DD-MMM-YYYY HH:mm:ss");
      this.displaySubmission.classification = item.classification.name;
      this.displaySubmission.access_level = item.access_level.name;
      this.displaySubmission.country =
        item.country.name + " (" + item.country.iso3 + ")";
      var lat = item.latitude != null ? item.latitude : "0.0";
      var long = item.longitude != null ? item.longitude : "0.0";
      this.displaySubmission.coordinates = lat + " " + long;
      this.displaySubmission.tags = JSON.parse(item.tags);
      this.displaySubmission.recent_abstract = item.recent_abstract;

      this.displaySubmission.project = null;
      this.displaySubmission.programme = null;
      if (item.collection != null) {
        this.displaySubmission.project = item.collection.name;
        if (item.collection.community != null) {
          this.displaySubmission.programme = item.collection.community.name;
        }
      }
      this.displaySubmission.created_at = item.created_at;
      this.displaySubmission.create_user = item.create_user;
      this.displaySubmission.thumbnail_link = item.thumbnail_link;
      this.changeView("show");
    },
    editSubmission(item) {
      this.highLightId = item.id;
      this.newItem.id = item.id;
      this.newItem.title = item.title;
      this;
      this.changeView("edit");
    },
    save() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        if (this.newItem.id != null) {
          apiCall({
            url: "/api/submission/" + this.newItem.id,
            data: this.newItem,
            method: "PUT",
          })
            .then((resp) => {
              if (resp.status == "error") {
                this.message = this.$t("anErrorOccurredMsg");
                this.color = "error";
                this.loading = false;
                this.snackbar = true;
              } else {
                this.message = this.$t("itemUpdatedSuccesfullyMsg");
                this.color = "orange";
                this.loading = false;
                this.snackbar = true;
                this.changeView("default");
                this.fetchsubmission(1);
              }
            })
            .catch((error) => {
              this.message = this.$t("anErrorOccurredMsg");
              this.color = "error";
              this.loading = false;
              this.snackbar = true;
            });
        } else {
          apiCall({
            url: "/api/submission",
            data: this.newItem,
            method: "POST",
          })
            .then((resp) => {
              if (resp.status == "error") {
                this.message = this.$t("anErrorOccurredMsg");
                this.color = "error";
                this.loading = false;
                this.snackbar = true;
              } else {
                this.message = this.$t("itemSubmittedSuccessfullyMsg");
                this.color = "success";
                this.loading = false;
                this.snackbar = true;
                this.changeView("default");
                this.fetchsubmission(1);
              }
            })
            .catch((error) => {
              this.message = this.$t("anErrorOccurredMsg");
              this.color = "error";
              this.loading = false;
              this.snackbar = true;
            });
        }
      }
    },

    search() {
      if (this.searchTerm == null) {
        this.searchButtonDisabled = true;
      } else {
        this.searchLoader = true;
        this.searchButtonDisabled = false;
        this.startsubmissionLoader();
        apiCall({
          url: "/api/submission?type=search&search=" + this.searchTerm,
          method: "GET",
        })
          .then((resp) => {
            this.filtersubmission(resp);
            this.searchLoader = false;
            this.stopsubmissionLoader();
            this.filteredSubmissions = true;
          })
          .catch((error) => {
            console.log(error.response);
            this.searchLoader = false;
            this.stopsubmissionLoader();
            this.message = this.$t("anErrorOccurredMsg");
            this.color = "error";
            this.snackbar = true;
          });
      }
    },
    changeView(view) {
      if (view == "default") {
        this.resetFields();
      } else if (view == "create") {
        this.resetFields();
      } else if (view == "edit") {
        view = "create";
      } else if (view == "show") {
        this.dashBreadcrumb = false;
        this.showBreadcrumb = true;
      }
      this.view = view;
    },
    changePage() {
      this.startsubmissionLoader();
      if (this.filteredSubmissions == true) {
        this.searchButtonDisabled = false;
        apiCall({
          url:
            "/api/submission?page=" +
            this.submissionPagination.current_page +
            "&type=search&search=" +
            this.searchTerm,
          method: "GET",
        })
          .then((resp) => {
            this.filtersubmission(resp);
            this.stopsubmissionLoader();
          })
          .catch((error) => {
            console.log(error.response);
            this.stopsubmissionLoader();
            this.message = this.$t("anErrorOccurredMsg");
            this.color = "error";
            this.snackbar = true;
          });
      } else {
        this.fetchsubmission(this.submissionPagination.current_page);
      }
    },
    deleteSubmission(item) {
      confirm(this.$t("itemDeleteConfirmationMsg")) && (this.delete = true);
      if (this.delete) {
        this.loading = true;
        this.itemIndex = item.id;
        apiCall({ url: "/api/submission/" + item.id, method: "DELETE" })
          .then((resp) => {
            this.message = this.$t("itemDeletedSuccessfullyMsg");
            this.color = "success";
            this.snackbar = true;
            this.loading = false;
            this.delete = false;
            this.itemIndex = null;
            this.fetchsubmission(this.submissionPagination.current_page);
          })
          .catch((error) => {
            this.message = this.$t("anErrorOccurredMsg");
            this.color = "error";
            this.snackbar = true;
            this.loading = false;
            this.delete = false;
            this.itemIndex = null;
            console.log(error.response);
          });
      }
    },
    openUploadDialog() {
      this.itemDialog = true;
      this.itemFile = null;
    },
    uploadItem() {
      if (this.$refs.itemForm.validate()) {
        this.itemLoading = true;
        let formData = new FormData();
        formData.append("files", this.itemFile, this.itemFile.name);
        apiCall({
          url: "/api/get-item",
          data: formData,
          method: "POST",
        })
          .then((resp) => {
            if (resp.status == "error") {
              this.message = this.$t("anErrorOccurredMsg");
              this.color = "error";
              this.snackbar = true;
              this.itemLoading = false;
            } else {
              this.newItem.itemFile = resp.filename;
              this.message = this.$t("itemUploadedSuccessfullyMsg");
              this.color = "success";
              this.snackbar = true;
              this.itemLoading = false;
              this.itemDialog = false;
            }
          })
          .catch((error) => {
            this.message = this.$t("anErrorOccurredMsg");
            this.color = "error";
            this.snackbar = true;
            this.itemLoading = false;
          });
      }
    },
    downloadItem() {
      this.downloadLoading = true;
      apiCall(
        {
          url: "/api/submission/" + this.displaySubmission.code,
          method: "GET",
        },
        {
          responseType: "blob",
        }
      )
        .then((resp) => {
          console.log(resp instanceof Blob);
          downloadFile(
            resp,
            `${this.displaySubmission.title}.${this.displaySubmission.file_type}`
          );
          this.message = this.$t("itemDownloadedSuccessfullyMsg");
          this.color = "success";
          this.snackbar = true;
          this.downloadLoading = false;
        })
        .catch((error) => {
          console.log(error);
          this.message = this.$t("anErrorOccurredMsg");
          this.color = "error";
          this.snackbar = true;
          this.downloadLoading = false;
        });
    },
    closeEventDate() {
      this.eventDate = false;
    },
  },
  computed: {
    ...mapGetters(["submission", "submissionPagination", "submissionLoader"]),
    formatEventDate() {
      if (this.newItem.eventDate != null) {
        const d = new Date(this.newItem.eventDate);
        const year = d.getFullYear();
        const date = d.getDate();
        const month = d.getMonth();

        return date + " " + this.monthNames[month].name + " " + year;
      }
    },
    dateToday() {
      var today = new Date();

      var timestamp =
        today.getFullYear() +
        "-" +
        this.months[today.getMonth()] +
        "-" +
        ("0" + today.getDate()).slice(-2);
      return timestamp;
    },
    length: function () {
      return Math.ceil(
        this.submissionPagination.total / this.submissionPagination.per_page
      );
    },
    permissionLength: function () {
      return Math.ceil(
        this.permissionPagination.total / this.permissionPagination.per_page
      );
    },
  }
};
</script>
